import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import TableFilterDynamique from "components/Common/TableFilter/TableFilterDynamique";
import AddEditFeeTypeModal from "../modals/AddEditFeeTypeModal";
import FeesTypesTable from "../tables/FeesTypesTable";
import useFeeTypes from "../hooks/useFeeTypes";
import { FilterField } from "../../../components/Common/TableFilter/TableFilter";
import SettingsLayout from "../components/SettingsLayout";

const FeesTypes = () => {
  const { t } = useTranslation();
  const {
    feeTypes,
    infoPagination,
    loading,
    error,
    selectedFeeType,
    setSelectedFeeType,
    isModalOpen,
    setIsModalOpen,
    fetchFeeTypes,
    handleCreate,
    handleUpdate,
    handleDelete,
    handleGetClassLevels,
    classLevels
  } = useFeeTypes();

  const breadcrumbItems = [
    { label: "dashboard", path: "/dashboard" },
    { label: "fees_types", active: true },
  ];

  const [filters, setFilters] = useState<{
    [key: string]: string | number | null;
  }>({});

  useEffect(() => {
    fetchFeeTypes();
    handleGetClassLevels();
  }, [fetchFeeTypes]);

 

  const filterFields: FilterField[] = [
    { key: "search", label: t("search"), type: "text" },
    {
      key: "frequency",
      label: t("frequency"),
      type: "select",
      options: [
        { label: t("unique_payment"), value: "unique_payment" },
        { label: t("monthly_payment"), value: "monthly_payment" },
      ],
    },
    {
      key: "pricingModel",
      label: t("pricing_model"),
      type: "select",
      options: [
        { label: t("level_based_payment"), value: "level_based_payment" },
        { label: t("unique_payment"), value: "unique_payment" },
      ],
    },
  ];

  const handleSaveFeeType = async (feeTypeData: any) => {
    if (selectedFeeType) {
      await handleUpdate(selectedFeeType.id, feeTypeData);
    } else {
      await handleCreate(feeTypeData);
    }
    setIsModalOpen(false);
  };

  const handleEdit = (record: any) => {
    setSelectedFeeType(record);
    setIsModalOpen(true);
  };

  const handleFilter = (newFilters: {
    [key: string]: string | number | null;
  }) => {
    setFilters(newFilters);
    fetchFeeTypes(newFilters);
  };

  return (
    <SettingsLayout titleKey="fees_types" loading={loading}>

        <div className="d-flex mb-3 justify-content-end gap-2">
          <button
            className="btn btn-primary"
            onClick={() => {
              setSelectedFeeType(null);
              setIsModalOpen(true);
            }}
          >
            <i className="ti ti-plus me-2" />
            {t("add_fee_type")}
          </button>
          <TableFilterDynamique
            fields={filterFields}
            filters={filters}
            onApply={(newFilters) => handleFilter(newFilters)}
            onReset={() => {
              setFilters({});
              fetchFeeTypes({});
            }}
          />
        </div>

        <FeesTypesTable
          dataSource={feeTypes}
          onEdit={handleEdit}
          onDelete={handleDelete}
        />

        <AddEditFeeTypeModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          feeData={selectedFeeType}
          onSave={handleSaveFeeType}
          classLevels={classLevels}
        />
     </SettingsLayout>
  );
};

export default FeesTypes;
